import React from "react";
import { Box, Text, Flex, Icon } from "@chakra-ui/react";
import { FaUserCheck, FaExclamationTriangle } from "react-icons/fa";
import { LOMA_GREEN, LOMA_DARK_TEAL } from "../constants/colors";

interface ReferralBannerProps {
  isValid: boolean;
  inviterEmail?: string;
}

const ReferralBanner: React.FC<ReferralBannerProps> = ({ 
  isValid, 
  inviterEmail, 
}) => {
  if (isValid && inviterEmail) {
    return (
      <Box
        bg={`${LOMA_GREEN}10`}
        borderLeft="4px solid"
        borderLeftColor={LOMA_GREEN}
        borderRadius="md"
        p={4}
        mb={4}
      >
        <Flex align="center" gap={3}>
          <Icon as={FaUserCheck} color={LOMA_GREEN} boxSize={5} />
          <Text color={LOMA_DARK_TEAL} fontWeight="500" fontSize="sm">
            <Text as="span" fontWeight="600">
              {inviterEmail}
            </Text>{" "}
            has invited you to try Loma!
          </Text>
        </Flex>
      </Box>
    );
  }

  if (!isValid) {
    return (
      <Box
        bg="red.50"
        borderLeft="4px solid"
        borderLeftColor="red.400"
        borderRadius="md"
        p={4}
        mb={4}
      >
        <Flex align="center" gap={3}>
          <Icon as={FaExclamationTriangle} color="red.500" boxSize={5} />
          <Text color="red.700" fontWeight="500" fontSize="sm">
            Referral code not found, double check your code and try again.
            If this problem persists email{" "}
            <Text 
              as="a" 
              href="mailto:support@loma.ai"
              color="red.600"
              textDecoration="underline"
              fontWeight="600"
            >
              support@loma.ai
            </Text>
          </Text>
        </Flex>
      </Box>
    );
  }

  return null;
};

export default ReferralBanner; 